module.exports = __webpack_public_path__ + "static/media/background-initial.1d79d6ce.jpeg";